/* ==========================================================================
   Kaching Bundles — sticky add-to-cart bar: product name, and a working
   Add to Cart.

   The app's own Title setting is ignored on this bar whenever a deal block is
   present: Kaching substitutes the selected offer's name, so the bar read
   "Buy 1 Get 1 Free" and changed as the shopper picked a different bundle.
   The reference design names the product instead, so this puts the product
   name back and holds it when Kaching re-renders.

   The name is read from the app's own `product` attribute, so it follows the
   product title in Shopify with nothing to keep in step by hand.

   This is presentation only. Which bundle is selected, what it costs and what
   Add to Cart does are all untouched — the price beside the name still moves
   with the selection. To revert, remove the sv-kaching.js tag from
   layout/serevue.liquid and the app's own title comes back.

   Like sv-kaching.css, this depends on the app's class names and fails safe:
   if Kaching rename them the bar simply keeps the app's own title.
   ========================================================================== */
(function () {
  'use strict';

  var BAR = 'kaching-bundles-sticky-atc';
  var TITLE = '.kaching-bundles-sticky-atc__title';

  function productTitle(bar) {
    try {
      var p = JSON.parse(bar.getAttribute('product') || '{}');
      if (p && p.title) return String(p.title).trim();
    } catch (e) { /* fall through to the page heading */ }
    var h1 = document.querySelector('h1');
    return h1 ? h1.textContent.trim() : '';
  }

  /* Writing only when the text differs keeps the MutationObserver below from
     re-triggering itself: the write that follows a mutation settles on the
     second pass instead of looping. */
  function apply() {
    Array.prototype.forEach.call(document.querySelectorAll(BAR), function (bar) {
      var el = bar.querySelector(TITLE);
      if (!el) return;
      var want = productTitle(bar);
      if (!want || el.textContent.trim() === want) return;
      el.textContent = want;
    });
  }

  function bind() {
    apply();
    if (!window.MutationObserver) return;
    Array.prototype.forEach.call(document.querySelectorAll(BAR), function (bar) {
      if (bar.dataset.svTitleBound) return;
      bar.dataset.svTitleBound = '1';
      new MutationObserver(function () { window.setTimeout(apply, 0); })
        .observe(bar, { childList: true, subtree: true, characterData: true });
    });
  }

  /* The bar is injected by the app well after DOMContentLoaded, and its
     contents land in stages, so watch for it rather than assume a moment. */
  function start() {
    bind();
    [200, 600, 1200, 2500, 4000].forEach(function (ms) { window.setTimeout(bind, ms); });
    if (!window.MutationObserver) return;
    var watcher = new MutationObserver(function () {
      if (document.querySelector(BAR)) bind();
    });
    watcher.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () { watcher.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ==========================================================================
   Make the sticky bar's Add to Cart actually add.

   Kaching's own handler on that button scrolls the page to the deal block and
   stops there — it never calls /cart/add. Verified in their code:
   kaching-bundles.js calls window.scrollTo from the button's click handler and
   issues no cart request. So the bar reads "Add to Cart" but only jumps.

   Rather than rebuild an add (which would mean reimplementing their bundle,
   price and discount handling), this re-points the click at the page's own
   Add to Cart button. Kaching already keeps the product form's variant in step
   with the selected offer — picking "Buy 3 Get 3 Free" sets the form to that
   variant — so pressing the real button adds exactly the bundle showing on the
   bar, at its price, through the theme's normal path, which also opens the
   cart drawer.

   Capture phase on the document, so this runs before Kaching's own listener on
   the button and can stop the event reaching it.

   It fails safe: if the page's Add to Cart button is missing or disabled the
   event is left alone and Kaching's scroll happens as before.
   ========================================================================== */
(function () {
  'use strict';

  var STICKY_BUTTON = '.kaching-bundles-sticky-atc__button';
  var BAR = 'kaching-bundles-sticky-atc';

  function pageAddToCart() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    var btn = form.querySelector('[data-sv-atc], .sv-atc, button[type="submit"]');
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return null;
    return btn;
  }

  document.addEventListener('click', function (e) {
    var onSticky = e.target.closest && e.target.closest(STICKY_BUTTON);
    if (!onSticky || !onSticky.closest(BAR)) return;

    var real = pageAddToCart();
    if (!real) return; // nothing to hand off to — leave Kaching's behaviour alone

    e.preventDefault();
    e.stopPropagation();
    real.click();
  }, true);
})();
